import { render } from "./demo-day-investment-legal-information-form.vue?vue&type=template&id=4968d13f"
import script from "./demo-day-investment-legal-information-form.vue?vue&type=script&lang=js"
export * from "./demo-day-investment-legal-information-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__